/**
 * Watrly Card Component
 * =====================
 * مكون البطاقة
 */

import React from 'react';
import { useTheme } from '../../context/ThemeContext';
import './Card.css';

const Card = ({
  children,
  title,
  subtitle,
  icon,
  actions,
  footer,
  variant = 'default', // default | outlined | elevated | water
  padding = 'md', // sm | md | lg | none
  hoverable = false,
  clickable = false,
  selected = false,
  loading = false,
  className = '',
  onClick,
  ...props
}) => {
  const { isRTL } = useTheme();

  const classes = [
    'watrly-card',
    `watrly-card--${variant}`,
    `watrly-card--padding-${padding}`,
    hoverable && 'watrly-card--hoverable',
    clickable && 'watrly-card--clickable',
    selected && 'watrly-card--selected',
    loading && 'watrly-card--loading',
    className,
  ].filter(Boolean).join(' ');

  const handleClick = (e) => {
    if (clickable && onClick) {
      onClick(e);
    }
  };

  return (
    <div
      className={classes}
      onClick={handleClick}
      dir={isRTL ? 'rtl' : 'ltr'}
      role={clickable ? 'button' : undefined}
      tabIndex={clickable ? 0 : undefined}
      {...props}
    >
      {loading && (
        <div className="watrly-card__loading-overlay">
          <div className="watrly-card__spinner">
            <svg viewBox="0 0 24 24">
              <circle cx="12" cy="12" r="10" fill="none" strokeWidth="3" />
            </svg>
          </div>
        </div>
      )}

      {(title || subtitle || icon || actions) && (
        <div className="watrly-card__header">
          {icon && <div className="watrly-card__icon">{icon}</div>}
          <div className="watrly-card__titles">
            {title && <h3 className="watrly-card__title">{title}</h3>}
            {subtitle && <p className="watrly-card__subtitle">{subtitle}</p>}
          </div>
          {actions && <div className="watrly-card__actions">{actions}</div>}
        </div>
      )}

      <div className="watrly-card__body">{children}</div>

      {footer && <div className="watrly-card__footer">{footer}</div>}
    </div>
  );
};

// بطاقة إحصائيات
export const StatCard = ({
  title,
  value,
  change,
  changeType = 'neutral', // positive | negative | neutral
  icon,
  trend,
  className = '',
  ...props
}) => {
  const { isRTL } = useTheme();

  return (
    <div className={`watrly-stat-card ${className}`} dir={isRTL ? 'rtl' : 'ltr'} {...props}>
      <div className="watrly-stat-card__header">
        <span className="watrly-stat-card__title">{title}</span>
        {icon && <div className="watrly-stat-card__icon">{icon}</div>}
      </div>

      <div className="watrly-stat-card__value">{value}</div>

      {(change || trend) && (
        <div className={`watrly-stat-card__change watrly-stat-card__change--${changeType}`}>
          {changeType === 'positive' && (
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <polyline points="18 15 12 9 6 15" />
            </svg>
          )}
          {changeType === 'negative' && (
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <polyline points="6 9 12 15 18 9" />
            </svg>
          )}
          <span>{change}</span>
          {trend && <span className="watrly-stat-card__trend">{trend}</span>}
        </div>
      )}
    </div>
  );
};

export default Card;
